import React, { useEffect, useState, useRef } from 'react';
import downArrow from '../../assets/images/downArrow.svg';
import cross from '../../assets/images/cross.svg';

const AutoComplete = ({
  options = [],
  onChange = () => {},
  defaultValue = '',
  parentClassNames = '',
  isRequired = false,
  labelFontColor = '#ffffff',
  placeholder = 'Select Options',
  label = '',
  maxLength,
  onFocus = () => {},
}) => {
  const [inputValue, setInputValue] = useState(defaultValue);
  const [isOpen, setIsOpen] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const autoCompleteRef = useRef(null);

  useEffect(() => {
    setInputValue(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (autoCompleteRef.current && !autoCompleteRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    window.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Only filter when user is actively typing
    if (isOpen && inputValue && !options.includes(inputValue)) {
      const filtered = options.filter((option) =>
        option.toLowerCase().includes(inputValue.toLowerCase()),
      );
      setFilteredOptions(filtered);
    } else {
      // Show all options when dropdown is opened with a selected value
      setFilteredOptions(options);
    }
  }, [inputValue, options, isOpen]);

  const handleInputChange = (e) => {
    const value = e?.target?.value;
    setInputValue(value);
    setIsOpen(true);
    onChange(value);
  };

  const handleOptionClick = (option) => {
    setInputValue(option);
    setIsOpen(false);
    onChange(option);
  };

  const clearInput = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    setInputValue('');
    onChange('');
  };

  const openDropdown = () => {
    setIsOpen(true);
    setFilteredOptions(options);
  };

  return (
    <div className={`${parentClassNames} relative width-[100%]`} ref={autoCompleteRef}>
      <div className="flex gap-[2px]">
        <label style={{ color: labelFontColor }}>{label}</label>
        {isRequired ? <span className="text-red relative top-[-4px]">*</span> : ''}
      </div>
      <div className="flex items-center w-full rounded-lg bg-white pr-[10px] justify-between border border-lightgrey">
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder={placeholder}
          onClick={openDropdown}
          onFocus={() => {
            openDropdown();
            onFocus();
          }}
          className="w-full py-[15px] px-[10px]"
          maxLength={maxLength}
        />
        {inputValue ? (
          <img
            src={cross}
            alt="Clear"
            className="ml-2 w-4 h-4 cursor-pointer"
            onClick={clearInput}
          />
        ) : null}
        <img
          src={downArrow}
          alt="Down Arrow"
          className="ml-2 w-6 h-6 cursor-pointer"
          onClick={openDropdown}
        />
      </div>

      {isOpen && (
        <div
          className={`${
            filteredOptions.length > 0
              ? 'absolute z-10 mt-1 w-48 bg-white border rounded-md shadow-lg max-h-[200px] overflow-y-auto'
              : 'hidden'
          } w-full rounded-lg border border-lightgrey bg-white`}
        >
          {filteredOptions.map((option) => (
            <div
              key={option}
              onClick={() => handleOptionClick(option)}
              className={`py-2 px-4 cursor-pointer hover:bg-gray-100 ${
                inputValue === option ? 'bg-[#E9F6FF]' : ''
              }`}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AutoComplete;
